import { useTranslation } from "react-i18next";
import { useDeleteInvoice } from "@/api/invoice";
import { Button } from "@/components/ui/button";
import { Modal } from "@/components/ui/customs/modal";
import { Loader2 } from "lucide-react";

type LitigeDeleteModalProps = {
  closeModal: () => void;
  litigeId: string;
  isOpen: boolean;
};

export const LitigeDeleteModal = ({ closeModal, litigeId, isOpen }: LitigeDeleteModalProps) => {
  const { t } = useTranslation(["boClients", "common"]);
  const { mutateAsync: deleteLitige, isPending } = useDeleteInvoice();

  const handleDelete = async () => {
    await deleteLitige(litigeId);
    closeModal();
  };

  return (
    <Modal
      open={isOpen}
      onClose={closeModal}
      title={t("invoicesLitigeDeleteModal.title")}
      description={t("invoicesLitigeDeleteModal.description")}
      size="sm"
      dismissible={!isPending}
      footer={
        <div className="flex w-full gap-2">
          <Button
            type="button"
            variant="outline"
            onClick={closeModal}
            disabled={isPending}
            className="flex-1"
          >
            {t("common:actions.cancel")}
          </Button>
          <Button
            type="button"
            variant="destructive"
            onClick={handleDelete}
            disabled={isPending}
            className="flex-1"
          >
            {isPending ? (
              <Loader2 className="animate-spin" />
            ) : (
              t("invoicesLitigeDeleteModal.submit")
            )}
          </Button>
        </div>
      }
    />
  );
};
